<template>
<div>
	<indexHeader ref="indexHeader"></indexHeader>
  <div id="app">
    <div v-if="token" id="pdf_con">
      <div class="page page1">
        <h1>企业信用报告</h1>
        <h2>信用培训专用版</h2>
        <div class="qy_info">
          <p>报 告 编 号：{{BH}}</p>
          <p>企 业 名 称：{{qymc}}</p>
          <p>信用服务机构：浙江汇信科技有限公司</p>
        </div>
      </div>
      <div class="page page2">
        <!--<div class="gz"></div>-->
        <div class="pageHeader clearfix">
          <span>企业信用培训专用</span>
          <em>{{qymc}}</em>
        </div>
        <h3>重要申明</h3>
        <p>1. 本报告生成时间为 {{yearSJ}} 年 {{monSJ}} 月 {{daySJ}} 日 {{hourSJ}} 时 {{minSJ}} 分，你所看到的内容为截止时间点近 2 年的数据快照。</p>
        <p>2. 本报告的著作权属于浙江汇信科技有限公司，未经书面许可，不得擅自复制、摘录、编辑、转载、披露和发表。</p>
        <p>3. 本报告仅供查询机构参考，不起任何证明作用。且报告仅限查询依照法律法规规章所规定的查询用途使用，不得擅自向任何非查询人或机构泄露和发布本报告的所涉及的任何信息。
          本报告内容是根据国家权威网站公开信息所得结果，汇信科技不对查询结果的准确性、真实性负责。使用本报告产生的任何后果，汇信科技概不负责。</p>
        <p>4. 征信机构承诺保持其客观、中立的地位，并保证将这一原则贯穿于信息汇总、加工、整合的全过程中。</p>
        <p>5. 请妥善保管本报告，并注意保密。</p>
        <div style="overflow: hidden;width: 730px;height: 520px">
          <img v-for="item in fjList" v-if="item.fjType == 3 "
               :src=" 'data:image/jpg;base64,' + item.fileBase64"
               :key="item.fjId" width="730px" height="520px">
        </div>
      </div>
      <div class="page page3">
        <h3>目录</h3>
        <div class="ml_title" v-for="(item,index) in ml">
          <div class="ml_child clearfix" style="font-weight: bold">
            <div class="ml_child_l">{{item.title}}</div>
            <div class="dline"></div>
            <div class="em">{{item.page}}</div>
          </div>
          <div class="ml_child clearfix" v-for="(child,child_index) in item.item" style="text-indent: 2em;">
            <div class="ml_child_l">
              {{index + 1}}.{{child_index + 1}} {{child.title}}
            </div>
            <div class="dline"></div>
            <div class="em">{{child.page}}</div>
          </div>
        </div>
      </div>
      <div class="info" v-if="data">
        <div class="info_con" v-for="(item,index) in ml">
          <div class="info_con_h1">{{item.title}}
           <div v-if="index == 3">
             <div class="else_content">
             <div v-for="item in data.xxbg.xybgPgs">
                 {{item.pgYj}}
             </div>
            </div>
          </div>
          <div v-else-if="index == 4" class="clearfix" style="height: 1045px;">
            <div v-for="item in fjList" :key="item.fjId"
                 v-if="item.fjType == 1 || item.fjType == 2"
                 style="margin-bottom:10px;float: left;width: 340px; margin: 0 10px 10px 0; height: 500px">
             <img :src="'data:image/jpg;base64,' + item.fileBase64" width="100%" height="100%">
             </div>
          </div>
           <div v-else-if="index == 5" style="height: 950px;" >
            <div v-if="zmData && qyFwnr == 2" class="pxzm_con">
               <h1>信用培训证明</h1>
               <p>{{zmData.qyFdxm}} 系 {{zmData.qyMc}} 法定代表人，授权{{zmData.pxrXm}}参加我司举办的信用培训课程，并于{{zmData.xxglTgrqN}}年{{zmData.xxglTgrqY}}月{{zmData.xxglTgrqR}}日通过培训考试。</p>
               <p>课程内容如下：</p>
               <p v-for="item in zmData.kcMc" style="margin-bottom: 20px">
              《{{item}}》
               </p>
               <p style="margin-bottom: 40px">已完成3学时课程，课后测评得分{{zmData.xxglKstgdf}}分（满分100分），培训成绩合格。</p>
               <p>特此证明。</p>
               <div class="sm">
               <p>信用服务机构名称：{{zmData.xyjgmc}}</p>
               <p>{{zmData.pxzmrqN}}年{{zmData.pxzmrqY}}月{{zmData.pxzmrqR}}日</p>
               </div>
            </div>
             <div v-else>
               <div v-for="item in fjList" :key="item.fjId"
                    v-if="item.fjType == 6"
                    style="margin-bottom:10px;float: left;width: 340px; margin: 0 10px 10px 0; height: 500px">
                 <img :src="'data:image;base64,' + item.fileBase64" width="100%" height="100%">
               </div>
             </div>
          </div>
          <div v-else-if="index == 6" class="clearfix" style="height: 700px;">
            <div v-for="item in fjList" :key="item.fjId"
                 v-if="item.fjType == 5"
                 style="margin-bottom:10px;float: left;width: 340px; margin: 0 10px 10px 0; height: 500px">
              <img :src="'data:image/jpg;base64,' + item.fileBase64" width="100%" height="100%">
            </div>
          </div>
        </div>
          <div class="info_con" v-for="(child,child_index) in item.item">
            <div class="info_con_h2">{{index + 1}}.{{child_index + 1}} {{child.title}}</div>
            <div v-if="child.code == 'xybgGss'">
              <table class="gsxx" v-if="data.xxbg.xybgGss && data.xxbg.xybgGss.length">
                <tbody>
                <tr><th>企业名称：</th><td>{{data.xxbg.xybgGss[0].gsQymc}}</td></tr>
                <tr><th>统一社会信用代码：</th><td>{{data.xxbg.xybgGss[0].gsXydm}}</td></tr>
                <tr><th>法定代表人：</th><td>{{data.xxbg.xybgGss[0].gsFrxm}}</td></tr>
                <tr><th>注册资本：</th><td>{{data.xxbg.xybgGss[0].gsZczb}}</td></tr>
                <tr><th>成立日期：</th><td>{{data.xxbg.xybgGss[0].gsClrq}}</td></tr>
                <tr><th>所属行业：</th><td>{{data.xxbg.xybgGss[0].gsSyhy}}</td></tr>
                <tr><th>经营状态：</th><td>{{data.xxbg.xybgGss[0].gsJyzt}}</td></tr>
                <tr><th>企业类型：</th><td>{{data.xxbg.xybgGss[0].gsQylx}}</td></tr>
                <tr><th>注册地址：</th><td>{{data.xxbg.xybgGss[0].gsZcdz}}</td></tr>
                <tr><th>营业期限：</th><td>{{data.xxbg.xybgGss[0].gsYyqx}}</td></tr>
                <tr><th>经营范围：</th><td>{{data.xxbg.xybgGss[0].gsJyfw}}</td></tr>
                <tr><th>登记机关：</th><td>{{data.xxbg.xybgGss[0].gsDjjg}}</td></tr>
                <tr><th>核准日期：</th><td>{{data.xxbg.xybgGss[0].gsHzrq}}</td></tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgGds'">
              <table class="gdxx" v-if="data.xxbg.xybgGds && data.xxbg.xybgGds.length">
                <tbody>
                <tr><th>序号</th><th>股东</th><th>股东类型</th>
                  <th>认缴出资额（万元）</th><th>币种</th><th>认缴出资日期</th></tr>
                <tr v-for="item in data.xxbg.xybgGds" :key="item.gdId">
                  <td>{{item.gdXh}}</td>
                  <td>{{item.gdXm}}</td>
                  <td>{{item.gdLx}}</td>
                  <td>{{item.gdRjcz}}</td>
                  <td>{{item.gdBz}}</td>
                  <td>{{item.gdRjczrq}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgBgs'">
              <table class="gdxx" v-if="data.xxbg.xybgBgs && data.xxbg.xybgBgs.length">
                <tbody>
                <tr><th>变更事项</th><th>变更内容</th><th>变更后内容</th><th>变更次数</th>
                  <th>核准日期</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgBgs">
                  <td>{{item.bgSx}}</td>
                  <td>{{item.bgNr}}</td>
                  <td>{{item.bgHnr}}</td>
                  <td>{{item.bgCs}}</td>
                  <td>{{item.bgRq}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgSxrs'">
              <table class="gdxx" v-if="data.xxbg.xybgSxrs && data.xxbg.xybgSxrs.length">
                <tbody>
                <tr><th>被执行人姓名/名称</th><th>统一社会信用代码</th><th>法定代表人</th>
                  <th>执行法院</th><th>案号</th><th>发布时间</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgSxrs">
                  <td>{{item.sxrXm}}</td>
                  <td>{{item.sxrXydm}}</td>
                  <td>{{item.sxrFrxm}}</td>
                  <td>{{item.sxrZcfy}}</td>
                  <td>{{item.sxrAh}}</td>
                  <td>{{item.sxrFbsj}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgSxs'">
              <table class="gdxx">
                <tbody>
                <tr>
                  <th>失信类型</th><th>列入部门</th>
                  <th>列入时间</th><th>列入原因</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgSxs">
                  <td>{{item.sxLx}}</td>
                  <td>{{item.sxLrbm}}</td>
                  <td>{{item.sxLrsj}}</td>
                  <td>{{item.sxLryy}}</td>
                </tr>
                <tr>
                  <th>列入依据</th><th>处罚文号</th>
                  <th>处罚结果</th><th>发布时间</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgSxs">
                  <td>{{item.sxLryj}}</td>
                  <td>{{item.sxCfwh}}</td>
                  <td>{{item.sxCfjg}}</td>
                  <td>{{item.sxFbsj}}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-else-if="child.code == 'xybgKts'">
              <table class="gdxx" v-if="data.xxbg.xybgKts && data.xxbg.xybgKts.length">
                <tbody>
                <tr>
                  <th>法院</th>
                  <th>法庭</th>
                  <th>开庭日期</th>
                  <th>案号</th>
                  <th>案由</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgKts">
                  <td>{{item.ktFy}}</td>
                  <td>{{item.ktFt}}</td>
                  <td>{{item.ktKtrq}}</td>
                  <td>{{item.ktAh}}</td>
                  <td>{{item.ktAy}}</td>
                </tr>
                <tr>
                  <th>承办部门</th>
                  <th colspan="2">审判长/主审人</th>
                  <th>公诉人/原告/上诉人/申请人</th>
                  <th>被告/被告人/被上诉人/被申请人</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgKts">
                  <td>{{item.ktCbbm}}</td>
                  <td colspan="2">{{item.ktSpz}}</td>
                  <td>{{item.ktGsr}}</td>
                  <td>{{item.ktBg}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgFys'">
              <table class="gdxx" v-if="data.xxbg.xybgFys && data.xxbg.xybgFys.length">
                <tbody>
                <tr><th>公告类型</th><th>公告人</th>
                  <th>当事人</th><th>公告内容</th>
                  <th>公告日期</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgFys">
                  <td>{{item.fyGglx}}</td>
                  <td>{{item.fyGgr}}</td>
                  <td>{{item.fyDsr}}</td>
                  <td>{{item.fyGgnr}}</td>
                  <td>{{item.fyGgrq}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgWfs'">
              <table class="gdxx"  v-if="data.xxbg.xybgWfs && data.xxbg.xybgWfs.length">
                <tbody>
                <tr><th>列入严违期限</th><th>列入严违日期</th>
                  <th>严违届满日期</th><th>列入严违文号</th>
                  <th>年份</th><th>列入严违文号序号</th></tr>
                <tr v-for="item in data.xxbg.xybgWfs">
                  <td>{{item.wfQx}}</td>
                  <td>{{item.wfRq}}</td>
                  <td>{{item.wfJmqx}}</td>
                  <td>{{item.wfWh}}</td>
                  <td>{{item.wfNf}}</td>
                  <td>{{item.wfWhxh}}</td>
                </tr>
                <tr>
                  <th>严违失信类型</th><th>列入严违依据数量</th>
                  <th>列入严违机关</th><th>列入严违原因</th>
                  <th>列入严违说明</th><th>严违公示日期</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgWfs">
                  <td>{{item.wfSxlx}}.</td>
                  <td>{{item.wfYjsl}}</td>
                  <td>{{item.wfJg}}</td>
                  <td>{{item.wfYy}}</td>
                  <td>{{item.wfSm}}</td>
                  <td>{{item.wfGsrq}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgXzs'">
              <table class="gdxx" v-if="data.xxbg.xybgXzs && data.xxbg.xybgXzs.length">
                <tbody>
                <tr><th>处罚决定书文号</th><th>违法行为类型</th>
                  <th>行政处罚内容</th><th>处罚类型</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgXzs">
                  <td>{{item.xzWh}}</td>
                  <td>{{item.xzXwlx}}</td>
                  <td>{{item.xzNr}}</td>
                  <td>{{item.xzCflx}}</td>
                </tr>
                  <tr>
                  <th>罚款金额</th><th>没收金额</th>
                  <th>处罚决定日期</th><th>处罚决定机关</th>
                  </tr>
                  <tr v-for="item in data.xxbg.xybgXzs">
                  <td>{{item.xzFkje}}</td>
                  <td>{{item.xzMsje}}</td>
                  <td>{{item.xzJdrq}}</td>
                  <td>{{item.xzJdjg}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgYcs'">
              <table class="gdxx"  v-if="data.xxbg.xybgYcs && data.xxbg.xybgYcs.length">
                <tbody>
                <tr><th>列入经营异常名录原因类型</th><th>列入日期</th>
                  <th>列入决定机关</th><th>列入事实和事由</th>
                  <th>处罚文号</th><th>年度</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgYcs">
                  <td>{{item.ycYylx}}</td>
                  <td>{{item.ycLrrq}}</td>
                  <td>{{item.ycJdjg}}</td>
                  <td>{{item.ycSy}}</td>
                  <td>{{item.ycWh}}</td>
                  <td>{{item.ycNd}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgCcs'">
              <table class="gdxx" v-if="data.xxbg.xybgCcs && data.xxbg.xybgCcs.length">
                <tbody>
                <tr><th>抽查产品</th><th>检测机构</th>
                  <th>抽查时间</th><th>抽查结果</th>
                  <th>抽查计划名称</th><th>抽查计划类型</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgCcs">
                  <td>{{item.ccCp}}.</td>
                  <td>{{item.ccJcjg}}</td>
                  <td>{{item.ccSj}}</td>
                  <td>{{item.ccJg}}</td>
                  <td>{{item.ccJhmc}}</td>
                  <td>{{item.ccJhlx}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgQss'">
              <table class="gdxx" v-if="data.xxbg.xybgQss && data.xxbg.xybgQss.length">
                <tbody>
                <tr><th>欠税余额</th><th>欠税税种</th>
                  <th>纳税人名称</th><th>纳税人识别号</th>
                  <th>主管税务机关</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgQss">
                  <td>{{item.qsYe}}</td>
                  <td>{{item.qsSz}}</td>
                  <td>{{item.qsMc}}</td>
                  <td>{{item.qsSbh}}</td>
                  <td>{{item.qsJg}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgXflss'">
              <table class="gdxx"  v-if="data.xxbg.xybgXflss && data.xxbg.xybgXflss.length">
                <tbody>
                <tr><th>培训日期</th><th>培训处罚事项</th><th>处罚文号</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgXflss">
                  <td>{{item.xflsRq}}</td>
                  <td>{{item.xflsSx}}</td>
                  <td>{{item.xflsWh}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
            <div v-else-if="child.code == 'xybgCfjls'">
              <table class="gdxx"  v-if="data.xxbg.xybgCfjls && data.xxbg.xybgCfjls.length">
                <tbody>
                <tr>
                  <th>所履行的处罚文号</th>
                  <th>处罚内容</th><th>履行日期</th>
                  <th>履行证明材料</th>
                </tr>
                <tr v-for="item in data.xxbg.xybgCfjls">
                  <td>{{item.cfjlWh}}</td>
                  <td>{{item.cfjlNr}}</td>
                  <td>{{item.cfjlRq}}</td>
                  <td>{{item.cfjlCl}}</td>
                </tr>
                </tbody>
              </table>
              <div class="else_content" v-else>
                截止 {{yearSJ}} 年 {{monSJ}}月 {{daySJ}}日，根据国内相关网站检索及汇信科技数据库分析，未查询到相关信息。不排除因信息公开来源尚未公开、公开形式存在差异等情况导致的信息与客观事实不完全一致的情形。仅供客户参考。
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--<a id="bgDownload" style="display: none" :download=""></a>-->
    <!--<div class="print" v-if="!isPrint && token" @click="startPrint()">加盖电子签章</div>-->
  </div>
	<indexFooter></indexFooter>
</div>
</template>
<script type="text/ecmascript-6">
import "babel-polyfill"; //IE9，模拟ES6环境
import { cookie } from "@/common/js/cookies.js";
import jsPDF from 'jspdf'
import indexHeader from "@/components/index/index_header";
import indexFooter from "@/components/index/index_footer";
export default {
  name: "app",
  data() {
    return {
      qyId: null,
      pxrId: null,
      isPrint: false,
      fjList: "",
      zmData: "",
      ml: [
        {
          title: "一、基本信息",
          page: 1,
          item: [
            {
              title: "工商基本信息",
              page: 1,
              code: "xybgGss"
            },
            {
              title: "股东信息",
              page: 1,
              code: "xybgGds"
            },
            {
              title: "变更信息",
              page: 1,
              code: "xybgBgs"
            }
          ]
        },
        {
          title: "二、风险信息",
          page: 1,
          item: [
            { title: "被执行人信息", page: 1, code: "xybgSxrs" },
            { title: "失信信息", page: 1, code: "xybgSxs" },
            { title: "裁判文书信息", page: 1, code: "" },
            { title: "开庭公告", page: 1, code: "xybgKts" },
            { title: "法院公告", page: 1, code: "xybgFys" },
            { title: "严重违法", page: 1, code: "xybgWfs" },
            { title: "行政处罚", page: 1, code: "xybgXzs" },
            { title: "经营异常信息", page: 1, code: "xybgYcs" },
            { title: "抽查检查", page: 1, code: "xybgCcs" },
            { title: "欠税信息", page: 1, code: "xybgQss" }
          ]
        },
        {
          title: "三、信用培训信息",
          page: 1,
          item: [
            { title: "信用培训历史记录", page: 1, code: "xybgXflss" },
            { title: "履行行政处罚记录", page: 1, code: "xybgCfjls" }
          ]
        },
        {
          title: "四、评估意见",
          page: 1
        },
        {
          title: "附录1、 履行行政处罚的证明材料",
          page: 1
        },
        {
          title: "附录2、 参加信用培训证明材料",
          page: 1
        },
        {
          title: "附录3、 信用承诺书",
          page: 1
        }
      ],
      data: null,
      yearSJ: "",
      monSJ: "",
      daySJ: "",
      hourSJ: "",
      minSJ: "",
      onePageHeight: 1135,
      BH: "",
      qymc: "",
      qyFwnr: null
    };
  },
  computed: {
    token() {
      return cookie.get("xyxf_token_qt");
    }
  },
  created: function() {
    this.qyId = this.$route.query.qyId;
    this.pxrId = this.$route.query.pxrId;
  },
  mounted() {
    let _self = this;
    if(_self.token){
      _self.xybgYlQt(function () {
        _self.getFJ(function(){
          if(_self.qyFwnr != 1){
            _self.pxzm(function(){
              _self.reloadHtml();
              _self.pageNum();
              _self.startPrint();
              window.scroll(0,0);
              setTimeout(function() {
                _self.printPDF();
              }, 500);
            });
          }else{
            _self.reloadHtml();
            _self.pageNum();
            _self.startPrint();
            window.scroll(0,0);
              setTimeout(function() {
                _self.printPDF();
              }, 500);
          }
        });
      });
    }else{
      _self.$message({
        showClose: true,
        message: '请先登录！',
        type: "error"
      });
      setTimeout(function(){
        window.location.href = SOWINURL + 'index/login';
      },2000);
    }


  },
  methods: {
    reloadHtml(){
      let _self = this;
      let title_H1 = document.getElementsByClassName('info_con_h1');

      for(let i = 0 ; i < title_H1.length ; i++){
        let title_H2 = title_H1[i].parentElement.getElementsByClassName('info_con_h2');

        if( i > 0 && i < title_H1.length - 2){
          let title_H1_currentPage = Math.ceil(_self.getElementToPageTop(title_H1[i])/_self.onePageHeight);
          let diff_h_H1 = title_H1_currentPage * _self.onePageHeight - _self.getElementToPageTop(title_H1[i]);
          title_H1[ i - 1 ].parentElement.style.paddingBottom =  diff_h_H1 + 'px';
          // console.log( i + ':' );

        }
        for( let j = 0 ; j < title_H2.length ; j++ ){
          let title_H2_currentPage = Math.ceil(_self.getElementToPageTop(title_H2[j])/_self.onePageHeight);
          // console.log(title_H2[j].parentElement.offsetHeight);

          if(j < title_H2.length - 1){
            let x_con_h = title_H2[j].parentElement.offsetHeight + title_H2[j + 1].parentElement.offsetHeight + _self.getElementToPageTop(title_H2[j]) + 30;
            if( Math.ceil(x_con_h/_self.onePageHeight) == title_H2_currentPage){

            }else{
              // console.log( j );
             let diff_h_H2 = title_H2_currentPage * _self.onePageHeight - ( _self.getElementToPageTop(title_H2[j]) + title_H2[j].parentElement.offsetHeight );
             title_H2[j].parentElement.style.paddingBottom = diff_h_H2 + 'px';
            }

          }
        }
      }

    },
    pageNum(){
      let _self = this;
      let title_H1 = document.getElementsByClassName('info_con_h1');

      for(let i = 0 ; i < title_H1.length ; i++){
        let title_H2 = title_H1[i].parentElement.getElementsByClassName('info_con_h2');
        let title_H1_currentPage = Math.ceil(_self.getElementToPageTop(title_H1[i])/_self.onePageHeight);
        _self.ml[i].page = title_H1_currentPage;

        for( let j = 0 ; j < title_H2.length ; j++ ){
          let title_H2_currentPage = Math.ceil(_self.getElementToPageTop(title_H2[j])/_self.onePageHeight);
          _self.ml[i].item[j].page = title_H2_currentPage;

        }
      }

    },
    getElementToPageTop(el){
      if(el.parentElement) {
        return this.getElementToPageTop(el.parentElement) + el.offsetTop
      }
      return el.offsetTop
    },
    pxzm (callback) {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      ajax({
        method: 'post',
        url: SOWINURL + 'report/pxzm',
        data: {
          qyId: _self.qyId,
          pxrId: _self.pxrId,
        },
				headers:{
					'token': cookie.get("xyxf_token_qt")
				}
      }).then(function (json) {
        // console.log(json.data);
        if (json.data.result == 1) {
          _self.zmData = json.data.data;
        } else {
          _self.$message({
            showClose: true,
            message: json.data.errorcode,
            type: 'error'
          });
        }
        callback && callback();
        loading.close();

      }).catch(function (error) {
        console.log(error);
      });
    },
    getFJ(callback) {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      ajax({
        method: "get",
        url: SOWINURL + "index/qyrzDetails",
        params: {
          qyId: _self.qyId
        },
		headers:{
			'token': cookie.get("xyxf_token_qt")
		}
      })
        .then(function(json) {
          // console.log(json.data);
          if (json.data.result == 1) {
            _self.fjList = json.data.data.fjList;
            _self.qyFwnr = json.data.data.qy.qyFwnr;
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error"
            });
          }
          callback&&callback();
          loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    printPDF(){
      let _self = this;
      var target = document.getElementById('pdf_con');
      target.style.background = "#FFFFFF";
      // 794 1123
      const loading = this.$loading({
        lock: true,
        text: "报告生成中，正在加盖电子签章",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      html2canvas(target, {
        useCORS: true,
        allowTaint: true,
        onrendered:function(canvas) {
          var contentWidth = canvas.width;
          var contentHeight = canvas.height;

          //一页pdf显示html页面生成的canvas高度;
          var pageHeight = contentWidth / 592.28 * 841.89;
          //未生成pdf的html页面高度
          var leftHeight = contentHeight;
          //页面偏移
          var position = 0;
          //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          var imgWidth = 595.28;
          var imgHeight = 592.28/contentWidth * contentHeight;

          var pageData = canvas.toDataURL('image/jpeg', 1.0);

          var pdf = new jsPDF('', 'pt', 'a4');

          //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
          //当内容未超过pdf一页显示的范围，无需分页
          if (leftHeight < pageHeight) {
            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight );
          } else {
            while(leftHeight > 0) {
              pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight;
              position -= 841.89;
              //避免添加空白页
              if(leftHeight > 0) {
                pdf.addPage();
              }
            }
          }
          let datauri = pdf.output('dataurlstring');
          let base64 = datauri.substring(28);

          _self.setQz( base64 , function(){
            _self.isPrint = false;
            loading.close();
            // pdf.save("content.pdf");
          });
        }
      })
    },
    setQz (base64,callback){//加盖电子签章
      let _self = this;
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      ajax({
        method: "post",
        url: SOWINURL + "report/setQz",
        data: {
         qz : base64,
          lx : '7',
          qyId : _self.qyId
        },
		headers:{
			'token': cookie.get("xyxf_token_qt")
		}
      })
        .then(function(json) {
          // console.log(json.data);
          if (json.data.result == 1) {
            // window.open(json.data.data);
            window.location.href = json.data.data;
            callback && callback();
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error"
            });
          }
          loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    xybgYlQt(callback) {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      ajax({
        method: "post",
        url: SOWINURL + "report/xybgYlQt",
        data: {
          qyId: _self.qyId,
          pxrId: _self.pxrId
        },
		headers:{
			'token': cookie.get("xyxf_token_qt")
		}
      })
        .then(function(json) {
          // console.log(json.data);
          if (json.data.result == 1) {
            _self.data = json.data.data;
            _self.yearSJ = json.data.data.fm.N;
            _self.monSJ = json.data.data.fm.Y;
            _self.daySJ = json.data.data.fm.R;
            _self.hourSJ = json.data.data.fm.S;
            _self.minSJ = json.data.data.fm.F;
            _self.BH = json.data.data.fm.BH;
            _self.qymc = json.data.data.fm.qymc;
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error"
            });
            if(json.data.result == 2){
              setTimeout(()=>{
                //登录失效删除token
                cookie.delete('xyxf_token_qt');
                window.location.href = SOWINURL + 'index/login';
              },2000);
            }
          }
          callback && callback();
          loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    startPrint() {
      let _self = this;
      _self.isPrint = true;
      // window.scroll(0,0);
      // setTimeout(function() {
      //   _self.printPDF();
      // }, 500);
    }
  },
  components: {
	  indexHeader,
	  indexFooter
  },
  watch: {}
};
</script>

<style scoped lang="less" type="text/less">
* {
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  height: 100%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  li {
    list-style: none;
  }

  img {
    border: 0 none;
    vertical-align: top;
  }

  a {
    text-decoration: none;
  }
}

div {
  position: relative;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

h3 {
  margin-top: 28px;
  height: 54px;
  font-size: 30px;
  text-align: center;
}
p {
  text-indent: -1em;
  line-height: 54px;
  font-size: 14px;
  padding-left: 1em;
}

.gsxx {
  text-align: left;
  line-height: 60px;
  th {
    width: 187px;
  }
  td {
  }
}
.gdxx {
  width: 100%;
  text-align: left;
  border-collapse: collapse;
  font-size: 16px;
  border-right: 1px solid #000;
  border-top: 1px solid #000;
  th {
    text-align: center;
    font-weight: normal;
    padding: 10px 10px;
    line-height: 30px;
  }
  td {
    // line-height: 50px;
    padding: 10px;
  }
  th,
  td {
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
  }
}
#pdf_con{
  width: 794px;
  margin: 0 auto;
  background: url("/static/images/watermark.png") repeat-y top;
}
.page {
  width: 734px;
  height: 1075px;
  padding: 30px;
  margin: 0 auto;
}

.info {
  width: 190mm;
  margin: 0 auto;
  .info_con_h1 {
    font-size: 28px;
    line-height: 90px;
    color: #0066ff;
    font-weight: bold;
  }
  .info_con_h2 {
    font-size: 18px;
    color: #0066ff;
    line-height: 80px;
  }
}

.ml_title {
  line-height: 42px;
  font-size: 14px;
  .ml_child {
    /*display: flex;*/
    position: relative;
    .ml_child_l {
      float: left;
      background: #fff;
      z-index: 1;
      padding-right: 7px;
    }
    .dline {
      border-bottom: 2px dotted #000;
      position: absolute;
      left: 0;
      top: 22px;
      width: 734px;
    }
    .em{
      float: right;
      background: #fff;
      text-align: center;
      text-indent: 0;
      padding: 0 7px;
    }
  }
}

.pageHeader {
  position: absolute;
  left: 10mm;
  top: 0;
  height: 10mm;
  line-height: 10mm;
  color: #808080;
  font-size: 14px;
  width: 190mm;
  border-bottom: 1px solid #808080;
  span {
    float: left;
  }
  em {
    float: right;
    font-style: normal;
  }
}
.print {
  width: 150px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  z-index: 10;
  border-radius: 20px;
  text-align: center;
  position: fixed;
  right: 5%;
  top: 10%;
  cursor: pointer;
  background: -webkit-linear-gradient(
    left,
    #0076ff,
    #00c9ff
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    right,
    #0076ff,
    #00c9ff
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    right,
    #0076ff,
    #00c9ff
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #0076ff, #00c9ff); /* 标准的语法 */
}
.gz {
  width: 125px;
  height: 124px;
  background: url("/static/images/gz.png") no-repeat center;
  position: absolute;
  right: 20px;
  top: 590px;
}
.page1 {
  background: url("/static/images/sy.png") no-repeat center;
  h1 {
    font-size: 60px;
    color: #315faa;
    position: absolute;
    left: 219px;
    top: 327px;
  }
  h2 {
    font-weight: normal;
    font-size: 16px;
    position: absolute;
    left: 340px;
    top: 429px;
    color: #fff;
  }
  .qy_info {
    color: #000;
    font-size: 18px;
    position: absolute;
    left: 243px;
    top: 550px;
    width: 332px;
    p {
      line-height: 32px;
    }
  }
}
.page3 {
  /*background: #F56C6C;*/
}
@page {
  margin-bottom: 0mm;
  margin-top: 0mm;
  margin-left: 0mm;
  margin-right: 0mm;
}
.else_content {
  font-size: 16px;
  line-height: 30px;
  font-weight: normal;
  color: #000;
}
.else_content > div {
  margin-bottom: 20px;
}
.pxzm_con{
    width:718px;
    height: 720px;
    padding-right:20px;
    font-size: 16px;
    background: url("/static/images/muban_bg.png") repeat;
    font-weight: normal;
    margin: 0 auto;
    position: relative;
    .sm{
      position: absolute;
      right: 5px;
      bottom: 75px;
      width: 600px;
      height: 110px;
      text-align: center;
       font-size: 16px;
      padding-top: 40px;
      /*background: url("/static/images/gz.png") no-repeat center;*/
      p{
        width: 100%;
        font-size: 16px;
      }
    }
    h1{
      height: 86px;
      line-height: 86px;
      font-size: 30px;
      text-align: center;
      color: #070f36;
      margin-bottom: 17px;
    }
    p{
      width:718px;
      margin: 0 auto;
      line-height: 38px;
      font-size: 16px;
      color: #070f36;
      text-indent: 2em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/report/report.vue